/* JT ornament builder: live preview, name fitting, and add to cart with the name attached */

const CAP = 0.647; // cap height of Alegreya SC, as a share of the font size
const ALLOWED = " !&'()+,-./0123456789:?ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÑÒÓÔÕÖØÙÚÛÜÝàáâãäåçèéêëìíîïñòóôõöøùúûüýÿ’";
// Same limits as the print file builder. The browser measures full letter widths, which are a hair
// wider than the inked shapes the builder measures, so anything allowed here also fits the real ornament.
const NAME = { cap: 5, capMin: 3.8, maxW: 66, minX: 0.82, r: 130, track: 0 };
const LINE2 = { cap: 3.6, capMin: 3, maxW: 50, minX: 0.8, r: 139.6, track: 0.06 };
const CENTER_Y = -108.5;
const JOLLY_MAX = 12;
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const clean = (v) => v.replace(/\s+/g, ' ').trim();
const badChars = (v) => [...new Set([...v].filter((c) => !ALLOWED.includes(c)))];
const money = (cents, cur) => {
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'USD' }).format(cents / 100);
  } catch (e) {
    return '$' + (cents / 100).toFixed(2);
  }
};

function arcPath(r) {
  const t = 0.5;
  const x = (r * Math.sin(t)).toFixed(2);
  const y = (CENTER_Y + r * Math.cos(t)).toFixed(2);
  return `M-${x} ${y}A${r.toFixed(2)} ${r.toFixed(2)} 0 0 0 ${x} ${y}`;
}

function init(root) {
  if (root.dataset.jtObBound) return;
  root.dataset.jtObBound = '1';
  const $ = (sel) => root.querySelector(sel);
  const $$ = (sel) => [...root.querySelectorAll(sel)];
  let data = {};
  try {
    data = JSON.parse($('[data-jt-ob-data]').textContent);
  } catch (e) {
    data = {};
  }

  const nameIn = $('[data-jt-ob-name]');
  const line2In = $('[data-jt-ob-line2]');
  const fit1 = $('[data-jt-ob-fit]');
  const fit2 = $('[data-jt-ob-fit2]');
  const out = {
    name: $('[data-jt-ob-out="name"]'),
    line2: $('[data-jt-ob-out="line2"]'),
    jolly: $('[data-jt-ob-out="jolly"]'),
  };
  const arcs = { name: $('[data-jt-ob-arc="name"]'), line2: $('[data-jt-ob-arc="line2"]') };
  const measure = $('[data-jt-ob-measure]');
  const addBtn = $('[data-jt-ob-add]');
  const addLabel = $('[data-jt-ob-addlabel]');
  const status = $('[data-jt-ob-status]');
  const qtyIn = $('[data-jt-ob-qtyin]');
  const hang = $('[data-jt-ob-hang]');
  const swatches = $$('[data-jt-ob-swatch]');
  const colorName = $('[data-jt-ob-colorname]');
  const placeholder = nameIn ? nameIn.getAttribute('placeholder') || '' : '';
  const jollySample = out.jolly ? out.jolly.textContent : 'Nana';

  const state = { style: root.dataset.style || 'nativity', color: 0, ok: false, problem: '' };
  const firstAvail = swatches.findIndex((sw) => !sw.disabled);
  state.color = firstAvail < 0 ? 0 : firstAvail;

  const setFit = (el, msg, bad) => {
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('is-bad', !!bad);
  };

  function width10(text, track) {
    if (!measure) return text.length * 6;
    measure.style.letterSpacing = track ? `${track}em` : '0';
    measure.textContent = text;
    try {
      return measure.getComputedTextLength();
    } catch (e) {
      return text.length * 6;
    }
  }

  // Same rules as the print file: shrink to fit, then narrow a little, then say it is too long
  function fitLine(text, cfg) {
    const a = fitT(text, cfg, cfg.track);
    if (!cfg.track || (a.ok && a.cap >= cfg.cap - 1e-6)) return a;
    const b = fitT(text, cfg, 0);
    if (!a.ok) return b;
    if (!b.ok) return a;
    return b.cap * b.xs > a.cap * a.xs ? b : a;
  }

  function fitT(text, cfg, track) {
    const w10 = width10(text, track);
    if (!w10) return { ok: true, size: cfg.cap / CAP, cap: cfg.cap, xs: 1, track };
    const widthAt = (size) => (w10 * size) / 10;
    let size = cfg.cap / CAP;
    let cap = cfg.cap;
    let xs = 1;
    if (widthAt(size) > cfg.maxW) {
      size = (cfg.maxW / w10) * 10;
      cap = size * CAP;
      if (cap < cfg.capMin) {
        cap = cfg.capMin;
        size = cap / CAP;
        xs = cfg.maxW / widthAt(size);
        if (xs < cfg.minX) {
          return { ok: false, most: Math.max(1, Math.floor((text.length * xs) / cfg.minX)) };
        }
      }
    }
    return { ok: true, size, cap, xs, track };
  }

  function drawLine(key, text, cfg) {
    const el = out[key];
    if (!el) return { ok: true };
    if (!text) {
      el.textContent = '';
      return { ok: true, empty: true };
    }
    const f = fitLine(text, cfg);
    if (!f.ok) return f;
    el.textContent = text;
    el.parentNode.setAttribute('font-size', (f.size * f.xs).toFixed(2));
    el.parentNode.style.letterSpacing = f.track ? `${f.track}em` : '0';
    if (arcs[key]) arcs[key].setAttribute('d', arcPath(cfg.r + (f.cap * f.xs) / 2));
    return f;
  }

  function renderNativity() {
    const raw = nameIn ? clean(nameIn.value) : '';
    const shown = raw || placeholder;
    let ok = true;
    const bad = badChars(shown);
    if (bad.length) {
      setFit(fit1, `We can't print ${bad.join(' ')} on this one. Letters, numbers, and & ' - . , ! ? work.`, true);
      ok = false;
    } else {
      const r = drawLine('name', shown, NAME);
      if (!r.ok) {
        setFit(fit1, `Too long for the ribbon. Try about ${r.most} characters.`, true);
        ok = false;
      } else if (!raw) {
        setFit(fit1, 'Type a name and it shows up on the ribbon.', false);
        ok = false;
      } else {
        setFit(fit1, r.xs < 0.999 || r.cap < NAME.cap - 0.05 ? 'Fits! We shrank it a little.' : 'Fits perfectly!', false);
      }
    }
    if (nameIn) nameIn.setAttribute('aria-invalid', ok || !raw ? 'false' : 'true');

    const l2raw = line2In ? clean(line2In.value) : '';
    const l2 = l2raw.toUpperCase();
    const bad2 = badChars(l2);
    let ok2 = true;
    if (bad2.length) {
      setFit(fit2, `We can't print ${bad2.join(' ')} on this one.`, true);
      ok2 = false;
    } else {
      const r2 = drawLine('line2', l2, LINE2);
      if (!r2.ok) {
        setFit(fit2, `Too long. Try about ${r2.most} characters.`, true);
        ok2 = false;
      } else {
        setFit(fit2, l2 ? '' : 'No second line.', false);
      }
    }
    if (line2In) line2In.setAttribute('aria-invalid', ok2 ? 'false' : 'true');
    state.problem = ok ? (ok2 ? '' : 'line2') : 'name';
    $$('[data-jt-ob-preset]').forEach((b) =>
      b.setAttribute('aria-pressed', String(clean(b.dataset.jtObPreset).toUpperCase() === l2))
    );
    return ok && ok2;
  }

  function renderJolly() {
    const raw = nameIn ? clean(nameIn.value) : '';
    const shown = (raw || jollySample).slice(0, JOLLY_MAX);
    if (out.jolly) {
      out.jolly.textContent = shown;
      const n = shown.length;
      out.jolly.style.setProperty('--name-size', n <= 5 ? 1 : n <= 8 ? 0.8 : n <= 10 ? 0.66 : 0.56);
    }
    const bad = badChars(raw);
    let ok = true;
    if (bad.length) {
      setFit(fit1, `We can't print ${bad.join(' ')}. Letters, numbers, and & ' - . , ! ? work.`, true);
      ok = false;
    } else if (raw.length > JOLLY_MAX) {
      setFit(fit1, `Up to ${JOLLY_MAX} characters on this one.`, true);
      ok = false;
    } else if (!raw) {
      setFit(fit1, 'Type a name and it shows up on the ornament.', false);
      ok = false;
    } else {
      setFit(fit1, 'Looking good!', false);
    }
    if (nameIn) nameIn.setAttribute('aria-invalid', ok || !raw ? 'false' : 'true');
    state.problem = ok ? '' : 'name';
    const sw = swatches[state.color];
    if (sw) {
      const cs = getComputedStyle(sw);
      const art = $('[data-art="jolly"]');
      art.style.setProperty('--orn', cs.getPropertyValue('--sw').trim() || '#e0252f');
      art.style.setProperty('--orn-d', cs.getPropertyValue('--swd').trim() || '#a3121a');
      art.style.setProperty('--ink-name', sw.dataset.ink === 'red' ? '#e0252f' : '#ffffff');
      swatches.forEach((b, i) => b.setAttribute('aria-checked', String(i === state.color)));
      if (colorName) colorName.textContent = sw.getAttribute('aria-label');
    }
    return ok;
  }

  function current() {
    if (state.style === 'jolly' && data.jolly) {
      const v = data.jolly.variants[state.color] || data.jolly.variants[0];
      return v ? { id: v.id, price: v.price, available: v.available, product: data.jolly.product } : null;
    }
    if (data.nativity) {
      const n = data.nativity;
      return { id: n.variant, price: n.price, available: n.available, product: n.product };
    }
    return null;
  }

  function render() {
    root.dataset.style = state.style;
    $$('[data-art]').forEach((a) => (a.hidden = a.dataset.art !== state.style));
    $$('[data-show]').forEach((el) => (el.hidden = el.dataset.show !== state.style));
    $$('[data-jt-ob-style]').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.jtObStyle === state.style)));
    if (nameIn) {
      nameIn.maxLength = state.style === 'jolly' ? JOLLY_MAX : 40;
      nameIn.placeholder = state.style === 'jolly' ? jollySample : placeholder;
    }
    state.ok = state.style === 'jolly' ? renderJolly() : renderNativity();
    const v = current();
    const qty = Math.max(1, Math.min(20, parseInt(qtyIn ? qtyIn.value : '1', 10) || 1));
    if (addLabel) addLabel.textContent = v ? `Add to cart · ${money(v.price * qty, data.currency)}` : 'Add to cart';
    if (addBtn) addBtn.disabled = !v || !v.available;
  }

  const jiggle = () => {
    const art = $(`[data-art="${state.style}"]`);
    if (!art || reduceMotion.matches) return;
    art.classList.remove('is-jiggle');
    void art.offsetWidth;
    art.classList.add('is-jiggle');
  };

  let raf = 0;
  const schedule = () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(render);
  };

  const clearStatus = () => {
    status.textContent = '';
    status.classList.remove('is-bad');
  };
  nameIn?.addEventListener('input', () => {
    schedule();
    jiggle();
    clearStatus();
  });
  line2In?.addEventListener('input', () => {
    schedule();
    clearStatus();
  });
  $$('[data-jt-ob-preset]').forEach((b) =>
    b.addEventListener('click', () => {
      line2In.value = b.dataset.jtObPreset;
      render();
      jiggle();
    })
  );
  $$('[data-jt-ob-style]').forEach((b) =>
    b.addEventListener('click', () => {
      state.style = b.dataset.jtObStyle;
      status.textContent = '';
      render();
      jiggle();
    })
  );
  swatches.forEach((sw, i) =>
    sw.addEventListener('click', () => {
      state.color = i;
      render();
      jiggle();
    })
  );
  $$('[data-jt-ob-qty]').forEach((b) =>
    b.addEventListener('click', () => {
      const n = (parseInt(qtyIn.value, 10) || 1) + Number(b.dataset.jtObQty);
      qtyIn.value = String(Math.max(1, Math.min(20, n)));
      render();
    })
  );
  qtyIn?.addEventListener('change', render);

  // Drag to tilt, tap to spin
  const stage = $('[data-jt-ob-stage]');
  let downAt = 0;
  stage?.addEventListener('pointermove', (e) => {
    if (reduceMotion.matches) return;
    const art = $(`[data-art="${state.style}"]`);
    const r = stage.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    art.style.setProperty('--ry', `${(px * 24).toFixed(1)}deg`);
    art.style.setProperty('--rx', `${(-py * 18).toFixed(1)}deg`);
  });
  stage?.addEventListener('pointerleave', () => {
    $$('[data-art]').forEach((a) => {
      a.style.setProperty('--rx', '0deg');
      a.style.setProperty('--ry', '0deg');
    });
  });
  stage?.addEventListener('pointerdown', () => (downAt = performance.now()));
  stage?.addEventListener('pointerup', () => {
    if (performance.now() - downAt > 350 || reduceMotion.matches) return;
    const art = $(`[data-art="${state.style}"]`);
    art.classList.remove('is-spinning');
    void art.offsetWidth;
    art.classList.add('is-spinning');
    setTimeout(() => art.classList.remove('is-spinning'), 950);
  });

  addBtn?.addEventListener('click', async () => {
    render();
    const v = current();
    const raw = nameIn ? clean(nameIn.value) : '';
    if (!raw) {
      status.textContent = 'Type a name first so we know what to print.';
      status.classList.add('is-bad');
      nameIn?.focus();
      return;
    }
    if (!state.ok || !v) {
      status.textContent =
        state.problem === 'line2'
          ? 'Check the line under the ribbon. It needs a quick fix before we can print it.'
          : 'Check the name above. It needs a quick fix before we can print it.';
      status.classList.add('is-bad');
      (state.problem === 'line2' ? line2In : nameIn)?.focus();
      return;
    }
    const properties = {};
    if (state.style === 'jolly') {
      properties['Name'] = raw;
    } else {
      properties['Ribbon name'] = raw;
      const l2 = line2In ? clean(line2In.value).toUpperCase() : '';
      properties['Second line'] = l2 || '(none)';
    }
    const qty = Math.max(1, Math.min(20, parseInt(qtyIn.value, 10) || 1));
    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
    const body = { items: [{ id: v.id, quantity: qty, properties }] };
    if (sectionIds.length) body.sections = sectionIds.join(',');
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    addBtn.disabled = true;
    addBtn.classList.add('is-busy');
    status.classList.remove('is-bad');
    status.textContent = 'Adding your ornament...';
    try {
      const res = await fetch(`${rootUrl}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not add it to the cart.');
      const cart = await fetch(`${rootUrl}cart.js`).then((r) => r.json());
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: root.dataset.section,
            data: { source: 'jt-ornament', itemCount: cart.item_count, productId: String(v.product), sections: json.sections },
          },
        })
      );
      status.textContent = `Added! ${qty > 1 ? qty + ' ornaments are' : 'Your ornament is'} in the cart.`;
      const r = addBtn.getBoundingClientRect();
      if (window.JT && window.JT.confetti) window.JT.confetti(r.left + r.width / 2, r.top + r.height / 2);
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') setTimeout(() => drawer.open(), 650);
    } catch (err) {
      status.textContent = err.message || 'Something went wrong. Try again in a moment.';
      status.classList.add('is-bad');
    } finally {
      addBtn.classList.remove('is-busy');
      render();
    }
  });

  render();
  if (document.fonts && document.fonts.load) {
    document.fonts.load('900 10px "Alegreya SC"').then(render, () => {});
    document.fonts.ready.then(render);
  }
}

const boot = (scope = document) => scope.querySelectorAll('[data-jt-ob]').forEach(init);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
else boot();
document.addEventListener('shopify:section:load', (e) => boot(e.target));
